export default "__VITE_ASSET__DxhNzMUv__"